import { SmartApplyApiError, StatusCode } from "../";
import { GrafferGqlError, GrafferGqlErrors } from "./gql-result";

export const SmartApplyApiErrorFromGqlError = (
  original: GrafferGqlErrors | GrafferGqlError,
): SmartApplyApiError => {
  if (
    original instanceof GrafferGqlErrors &&
    // 現行の backend の error presenter を経由する限り
    // あり得ないはず。
    original.errors.length !== 1
  ) {
    return new SmartApplyApiError(original.rawError);
  }

  const error: GrafferGqlError =
    original instanceof GrafferGqlErrors ? original.errors[0] : original;
  const apiError = new SmartApplyApiError(new Error(error.message));
  if (error.extensions) {
    apiError.response = {
      message: error.message,
      code: error.extensions.code,
    };
    apiError.status = StatusCode.fromStatusNumber(error.extensions.status);
  }
  return apiError;
};
